import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateCommission } from '~/services/AgentHub/AgentService';

import { EditCommissionParams } from '~/types/services/agentHub';

import { commissionQueryKeys } from './useListCommissions';

interface UpdateCommissionVariables {
  commissionId: string;
  data: EditCommissionParams;
}

interface UseUpdateCommissionOptions {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export function useUpdateCommission(options: UseUpdateCommissionOptions = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ commissionId, data }: UpdateCommissionVariables) => {
      return await updateCommission(commissionId, data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: commissionQueryKeys.all });
      options.onSuccess?.();
    },
    onError: (error: Error) => {
      options.onError?.(error);
    },
  });
}
